import { RegisterImages, NeonImageRegistry } from '@art-basel/artbasel-lib-neon';
import uploadImagesVideosIllustration from '@/images/imagesVideosUploadIllustration.svg';
import ubsLogo from '@/images/ubsLogo.svg';
import iconHyperlink from '@/images/iconHyperlink.svg';

export const initIcons = () => {
  RegisterImages.register();
  NeonImageRegistry.imageRegistry.addImage('upload-images-and-videos-illustration', uploadImagesVideosIllustration);
  NeonImageRegistry.imageRegistry.addImage('ubs-logo', ubsLogo);
  NeonImageRegistry.iconRegistry.addImage('icon-hyperlink', iconHyperlink);
};
